import React, { useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { useLocation } from 'react-router-dom';
import useNetworkStatus from '../../hooks/useNetworkStatus';
import NoInternetIcon from './NoInternetIcon';
import './NetworkOfflineDialog.scss';

const isLoginRoute = (pathname = '') => {
  const path = pathname.replace(/\/+$/, '') || '/';
  return path === '/' || path === '';
};

/**
 * Blocking no-internet popup. Cannot be dismissed until connectivity returns.
 * Hidden on the login page.
 */
const NetworkOfflineDialog = () => {
  const { pathname } = useLocation();
  const { isOffline, refresh, message } = useNetworkStatus();
  const hideOnLogin = isLoginRoute(pathname);
  const shouldShow = isOffline && !hideOnLogin;

  useEffect(() => {
    if (!shouldShow) return undefined;

    const intervalId = window.setInterval(() => {
      refresh();
    }, 3000);

    return () => window.clearInterval(intervalId);
  }, [shouldShow, refresh]);

  return (
    <Dialog
      open={shouldShow}
      disableEscapeKeyDown
      onClose={() => {}}
      className="network-offline-dialog"
      PaperProps={{ className: 'network-offline-dialog__paper' }}
      BackdropProps={{ className: 'network-offline-dialog__backdrop' }}
      aria-labelledby="network-offline-title"
      aria-describedby="network-offline-desc"
    >
      <DialogContent className="network-offline-dialog__content">
        <div className="network-offline-dialog__icon-wrap" aria-hidden>
          <NoInternetIcon size={56} className="network-offline-dialog__wifi-icon" />
        </div>

        <Typography
          id="network-offline-title"
          className="network-offline-dialog__title"
          component="h2"
        >
          {message}
        </Typography>

        <Typography
          id="network-offline-desc"
          className="network-offline-dialog__text"
        >
          Please check your network connection. This window will close
          automatically when the internet is available again.
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default NetworkOfflineDialog;
